module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.dialogRegion.tabs.usage":"Usage","views.dialogRegion.tabs.carbon":"Emissions"}}')
  delete Component.options._Ctor
}
